import React, { useMemo } from "react";
import ReactEcharts from "echarts-for-react";

const buildBins = (values, binWidth) => {
  if (!values || values.length === 0) return { labels: [], counts: [] };
  const min = Math.floor(Math.min(...values) / binWidth) * binWidth;
  const max = Math.ceil(Math.max(...values) / binWidth) * binWidth;
  const labels = [];
  const counts = [];
  for (let edge = min; edge < max; edge += binWidth) {
    labels.push(edge.toFixed(2));
    const upper = edge + binWidth;
    counts.push(values.filter((v) => v >= edge && v < upper).length);
  }
  return { labels, counts };
};

export const StcPressureHistogram = ({ readings }) => {
  const binWidth = 0.05;

  const { bins1, bins2 } = useMemo(() => {
    if (!readings) return { bins1: null, bins2: null };
    const p1 = readings.map((r) => r.pressure_1);
    const p2 = readings.map((r) => r.pressure_2);
    const allVals = [...p1, ...p2];
    const min = Math.floor(Math.min(...allVals) / binWidth) * binWidth;
    const max = Math.ceil(Math.max(...allVals) / binWidth) * binWidth;
    const labels = [];
    const counts1 = [];
    const counts2 = [];
    for (let edge = min; edge < max; edge += binWidth) {
      labels.push(edge.toFixed(2));
      const upper = edge + binWidth;
      counts1.push(p1.filter((v) => v >= edge && v < upper).length);
      counts2.push(p2.filter((v) => v >= edge && v < upper).length);
    }
    return {
      bins1: { labels, counts: counts1 },
      bins2: { labels, counts: counts2 },
    };
  }, [readings]);

  if (!bins1) return null;

  const option = {
    grid: { left: 50, right: 20, top: 30, bottom: 40 },
    xAxis: {
      type: "category",
      data: bins1.labels,
      name: "Pressure (bar)",
      nameTextStyle: { color: "#ccc", fontSize: 11 },
      axisLabel: { color: "#ccc", fontSize: 9, rotate: 45 },
    },
    yAxis: {
      type: "value",
      name: "Count",
      nameTextStyle: { color: "#ccc", fontSize: 11 },
      axisLabel: { color: "#ccc", fontSize: 10 },
    },
    tooltip: {
      trigger: "axis",
      confine: true,
    },
    legend: {
      data: ["Inlet", "Filtered"],
      textStyle: { color: "#ccc", fontSize: 11 },
      top: 0,
    },
    series: [
      {
        name: "Inlet",
        type: "bar",
        data: bins1.counts,
        barGap: "0%",
        itemStyle: { opacity: 0.7 },
      },
      {
        name: "Filtered",
        type: "bar",
        data: bins2.counts,
        barGap: "0%",
        itemStyle: { opacity: 0.7 },
      },
    ],
  };

  return (
    <ReactEcharts option={option} style={{ height: 280, width: "100%" }} />
  );
};
